// import { reactive } from 'vue'
import axios from 'axios'
import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
    //Store Variables
state: () => {
    return {
        user: JSON.parse(localStorage.getItem('user')) || {},
        token: localStorage.getItem('token') || '',
        last_visit: localStorage.getItem('last_visit') || '',
        isLoggedIn: localStorage.getItem('token') ? true : false,
        notif_settings: [],
    }
},
getters: {
    // getUser: (state) => state.user,

},
actions: {
    //Store Functions
    pingAPI() {
        return axios.get('ping')
    },
    login(user) {
        // console.log("Logging in with data from store:", user)
        return new Promise((resolve, reject) => {
            //commit('auth_request')
            axios.post('login', user)
            .then(resp => {
                // console.log("resp Error:")
                // console.log(resp)
                if (typeof(resp.data.token) == 'undefined' || typeof(resp.data.user) == 'undefined') {
                    localStorage.removeItem('token')
                    localStorage.removeItem('user')
                    this.isLoggedIn = false
                    reject({response: {data: 'Unknown server error'}})
                } else {
                    const token = resp.data.token
                    const user = resp.data.user
                    // console.log(resp.data.user)
                    // console.log(JSON.stringify(user).replace("\\", ""))
                    
                    localStorage.setItem('token', token)
                    localStorage.setItem('user', JSON.stringify(user).replace("\\", ""))
                    this.isLoggedIn = true
                    axios.defaults.headers.common['Authorization'] = token
                    resolve(resp)
                }
            })
            .catch(err => {
                // console.log("catch errors: ")
                if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(err.response.data);
                    // console.log(err.response.status);
                    // console.log(err.response.headers);
                } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(err.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', err.message);
                }

                // console.log(err.config);
                // commit('auth_error', err)
                // console.log(err)
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                reject(err)
            })
        })
    },
    logout(){
        // console.log("Logging out in store")
        return new Promise((resolve) => {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.isLoggedIn = false
            delete axios.defaults.headers.common['Authorization']
            resolve()
        })
    },
    signup(user){
        // console.log("Signing up user:", user)
        return new Promise((resolve, reject) => {
            axios.post('signup', user)
            .then(resp => {
                if (typeof(resp.data.token) == 'undefined' || typeof(resp.data.user) == 'undefined') {
                    // console.log("status Error")
                    // commit('auth_error')
                    localStorage.removeItem('token')
                    localStorage.removeItem('user')
                    this.isLoggedIn = false
                    reject({response: {data: 'Unknown server error'}})
                } else {
                    const token = resp.data.token
                    const user = resp.data.user

                    localStorage.setItem('token', token)
                    localStorage.setItem('user', JSON.stringify(user).replace("\\", ""))
                    this.isLoggedIn = true
                    axios.defaults.headers.common['Authorization'] = token
                    resolve(resp)
                }
            })
            .catch(err => {
                if (err.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(err.response.data);
                // console.log(err.response.status);
                // console.log(err.response.headers);
                } else if (err.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                // console.log(err.request);
                } else {
                // Something happened in setting up the request that triggered an Error
                // console.log('Error', err.message);
                }
                // console.log(err.config);
                // commit('auth_error', err)
                // console.log(err)
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                reject(err)
            })
        })
    },
    updateNotifsettings(data){
        // console.log("Signing up user:", user)
        return new Promise((resolve, reject) => {
            axios.post('update_notif_settings', data)
            .then(resp => {
                if (typeof(resp.data) == 'undefined') {
                    // console.log("status Error")
                    // commit('auth_error')
                    // this.isLoggedIn = false
                    reject({response: {data: 'Unknown server error'}})
                } else {
                    //Update User in local storage to reflect notif allowed state
                    // console.log(resp.data)
                    const notif_allowed = resp.data.notif_settings
                    // console.log(notif_allowed)

                    var existing = localStorage.getItem('user')
                    existing = existing ? JSON.parse(existing) : {}
                    existing['notif_allowed'] = notif_allowed
                    localStorage.setItem('user', JSON.stringify(existing))

                    // localStorage.setItem('token', token)
                    // localStorage.setItem('user', JSON.stringify(user).replace("\\", ""))
                    // this.isLoggedIn = true
                    // axios.defaults.headers.common['Authorization'] = token
                    resolve(resp)
                }
            })
            .catch(err => {
                if (err.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(err.response.data);
                // console.log(err.response.status);
                // console.log(err.response.headers);
                } else if (err.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                // console.log(err.request);
                } else {
                // Something happened in setting up the request that triggered an Error
                // console.log('Error', err.message);
                }
                // console.log(err.config);
                // commit('auth_error', err)
                // console.log(err)
                reject(err)
            })
        })
    },
    getNotifSettings(currentToken) {
        return new Promise((resolve, reject) => {
            //commit('auth_request')
            // console.log("Inside Store: " + currentToken)
            axios.get('notifSettings/' + currentToken)
            .then(resp => {
                if (typeof(resp.data.notif_settings) == 'undefined') {
                    this.notif_settings = []
                    reject({response: {data: 'Unknown server error'}})
                } else {
                    this.notif_settings = resp.data.notif_settings
                    // console.log(resp.data)
                    // console.log(JSON.stringify(user).replace("\\", ""))
                    
                    resolve(resp)
                }
            })
            .catch(err => {
                // console.log("catch errors: ")
                if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(err.response.data);
                    // console.log(err.response.status);
                    // console.log(err.response.headers);
                } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(err.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', err.message);
                }

                // console.log(err.config);
                // commit('auth_error', err)
                // console.log(err)
                this.notif_settings = []
                reject(err)
            })
        })
    },
    // checkFBToken({commit}, token){
    //     return new Promise((resolve, reject) => {
    //         axios.put('checkFBtoken', token)
    //         .then(resp => {
    //             let last_update = new Date()
    //             // console.log("Last update: " + last_update)
    //             localStorage.setItem('last_visit', last_update)
    //             commit('setLastVisit', last_update)
                
    //             resolve(resp)
    //         }).catch(err => {
    //             // commit('auth_error', err)
    //             reject(err)
    //         })
    //     })
    // },
    // setLastVisit(state, date) {
    //     state.last_visit = date
    // },
},
})